import dayjs from "dayjs";

export const MotorFields = [
  { type: "header", label: "Device Info" },
  { key: "device_type", label: "Device Type", map: { 2: "Tank", 1: "Motor" } },
  { key: "imei", label: "IMEI" },
  { key: "date", label: "Date", type: "date" },
  { key: "d26", label: "Config Version" },
  { key: "d39", label: "Software Version" },
  { key: "d40", label: "Hardware Version" },
  { key: "meter", label: "Meter Reading" },
  { key: "offline", label: "Connection", map: { 0: "Online", 1: "Offline" } },
  { key: "d38", label: "GSM Signal (dBm)" },
  { key: "d5", label: "Solar", factor: 1, unit: "V" },
  { key: "d6", label: "Battery", factor: 1, unit: "V" },
  { key: "i8", label: "Manual Mode", factor: 1 },

  { type: "header", label: "Power & Energy" },
  { key: "d19", label: "Raw kW", factor: 1 },
  { key: "d29", label: "Power Factor (PF)", factor: 1 },
  { key: "d10", label: "Raw kWh", factor: 1 },
  { key: "d11", label: "Raw V Avg", factor: 1 },
  { key: "d12", label: "L12 Voltage", unit: "V" },
  { key: "d13", label: "L23 Voltage", unit: "V" },
  { key: "d14", label: "L13 Voltage", unit: "V" },
  { key: "d15", label: "Raw I Avg", factor: 1 },
  { key: "d16", label: "Current R", factor: 1, unit: "A" },
  { key: "d17", label: "Current Y", factor: 1, unit: "A" },
  { key: "d18", label: "Current B", factor: 1, unit: "A" },
  { key: "d20", label: "R Power", factor: 1, signed: true },
  { key: "d21", label: "Y Power", factor: 1, signed: true },
  { key: "d22", label: "B Power", factor: 1, signed: true },
  { key: "d25", label: "Frequency", unit: "Hz" },

  { type: "header", label: "Motor Control" },
  { key: "i1", label: "Motor Status", map: { 1: "ON", 0: "OFF" } },
  {
    key: "d8",
    label: "Motor Error",
    map: {
      1: "No Error",
      2: "R Phase Fail",
      20: "Y Phase Fail",
      21: "B Phase Fail",
    },
  },
  { key: "d7", label: "Motor On Time", factor: 1 },
  { key: "d23", label: "Current M1", factor: 1 },
  { key: "d24", label: "Current M2", factor: 1 },

  { type: "header", label: "Inverter Details" },
  { key: "d33", label: "Invt Output Current", factor: 100, unit: "A" },
  { key: "d34", label: "Invt Output Voltage", factor: 100, unit: "V" },
  { key: "d35", label: "Invt Frequency", unit: "Hz" },
  { key: "d28", label: "Invt DC Bus Voltage", unit: "V" },
  { key: "d27", label: "Invt Error Code" },
  { key: "d41", label: "Invt Motor RPM" },
  { key: "d31", label: "IGBT Temperature", factor: 100, unit: "°C" },
  { key: "i7", label: "Inverter Timeout", factor: 1 },

  { type: "header", label: "Tank & Flow" },
  { key: "d2", label: "Tank Level", factor: 1 },
  { key: "d30", label: "Discharge", factor: 1 },
  { key: "d32", label: "Inst Flow", factor: 1 },
  { key: "d9", label: "Total Flow" },

  { type: "header", label: "Valve Settings" },
  { key: "i2", label: "Valve 1", map: { 1: "ON", 0: "OFF" } },
  { key: "d36", label: "Valve Open Sensor" },
  { key: "d37", label: "Valve Close Sensor" },
  { key: "i3", label: "Valve 2", map: { 1: "ON", 0: "OFF" } },
  { key: "i4", label: "Valve 3", map: { 1: "ON", 0: "OFF" } },
];

export const TankFields = [
  { type: "header", label: "Device Info" },
  { key: "device_type", label: "Device Type", map: { 2: "Tank", 1: "Motor" } },
  { key: "imei", label: "IMEI" },
  { key: "date", label: "Date", type: "date" },
  { key: "d26", label: "Config Version" },
  { key: "d39", label: "Software Version" },
  { key: "d40", label: "Hardware Version" },
  { key: "meter", label: "Meter Reading" },
  { key: "offline", label: "Connection", map: { 0: "Online", 1: "Offline" } },
  { key: "d38", label: "GSM Signal (dBm)" },
  { key: "d5", label: "Solar", factor: 1, unit: "V" },
  { key: "d6", label: "Battery", factor: 1, unit: "V" },

  { type: "header", label: "Tank & Flow" },
  { key: "d2", label: "Tank Level", factor: 1 },
  { key: "d3", label: "Tank Level %", factor: 1 },
  { key: "d1", label: "Tank Error code" },
  { key: "d31", label: "Level Sensor ADC" },

  { key: "d30", label: "Discharge", factor: 1 },
  { key: "d32", label: "Inst Flow", factor: 1 },
  { key: "d9", label: "Total Flow" },

  { type: "header", label: "Valve Settings" },
  { key: "i2", label: "Valve 1", map: { 1: "ON", 0: "OFF" } },
  { key: "d36", label: "Valve Open Sensor" },
  { key: "d37", label: "Valve Close Sensor" },
  { key: "i3", label: "Valve 2", map: { 1: "ON", 0: "OFF" } },
  { key: "i4", label: "Valve 3", map: { 1: "ON", 0: "OFF" } },
];

export const formatStatusValue = (field, value) => {
  if (value === null || value === undefined) return "N/A";
  if (field.type === "date") return dayjs(value).format("DD-MM-YYYY HH:mm:ss");
  if (field.map) return field.map[value] ?? value;

  const num = Number(value);
  if (!Number.isNaN(num) && field.factor) {
    const result = (num / field.factor).toFixed(field.factor === 100 ? 2 : 1);
    return field.unit ? `${result} ${field.unit}` : result;
  }

  return field.unit ? `${value} ${field.unit}` : value;
};

export const fieldsForDeviceType = (type) =>
  Number(type) === 2 ? TankFields : MotorFields;

// Compact "header highlights" — a small set of key readings displayed in
// the StatusPanel / LogsPage header (next to or below the device name) so
// you can see the headline values without scrolling the full grid.
// Returns the matching field-metadata objects from the per-type maps
// (label, factor, unit, map, etc.), in the listed order. Keys absent in
// the device's field map are silently dropped.
const HIGHLIGHT_KEYS_BY_TYPE = {
  1: ["d10", "d12", "d16", "d28", "d29"], // motor: kWh, V(R), A(R), KW, PF
  2: ["d2", "d3", "d9", "d5", "d6"],      // tank: level, level%, total flow, solar, battery
};

export const headerHighlightsForType = (type) => {
  const fields = fieldsForDeviceType(type);
  const wanted =
    HIGHLIGHT_KEYS_BY_TYPE[Number(type)] ||
    HIGHLIGHT_KEYS_BY_TYPE[1];
  return wanted
    .map((k) => fields.find((f) => f.key === k && f.type !== "header"))
    .filter(Boolean);
};
